import * as React from 'react';
import * as autoBind from 'react-autobind';
import Constants from '../../globals/Constants';
import Strings from '../../globals/Strings';
import {PopoverButton, TscButtonType, TscPopoverOrigin, Glyphs} from '@techsmith/tsc-cloud-style-guide';
import ColorSwatch from '../../assets/ColorSwatch.svg';
import Themeable from '../../types/Themeable';

export default class ColorPicker extends React.Component<ColorPickerProps, ColorPickerState> {
   readonly state: ColorPickerState = {displayColorPicker: false};

   constructor(props: ColorPickerProps) {
      super(props);
      autoBind(this);
   }

   componentDidMount() {
      if (!this.props.annotationColor) {
         this.handleChange(Constants.annotation.defaultColor);
      }
   }

   handleChange(color: string): void {
      const {setAnnotationColor, onColorChange} = this.props;

      setAnnotationColor(color);
      onColorChange(color);
   }

   getColorClass(): string {
      const {annotationColor} = this.props;
      const color = annotationColor.toLowerCase();

      if (color === Constants.annotationColors.white) {
         return Constants.colorClass.white;
      } else if (color === Constants.annotationColors.blue) {
         return Constants.colorClass.blue;
      } else if (color === Constants.annotationColors.green) {
         return Constants.colorClass.green;
      } else if (color === Constants.annotationColors.red) {
         return Constants.colorClass.red;
      } else {
         return Constants.colorClass.yellow;
      }
   }

   getColorText(color: string): string {
      if (color.toLowerCase() === Constants.annotationColors.white) {
         return Strings.accessibility.annotationToolbar.colors.white;
      } else if (color.toLowerCase() === Constants.annotationColors.blue) {
         return Strings.accessibility.annotationToolbar.colors.blue;
      } else if (color.toLowerCase() === Constants.annotationColors.green) {
         return Strings.accessibility.annotationToolbar.colors.green;
      } else if (color.toLowerCase() === Constants.annotationColors.red) {
         return Strings.accessibility.annotationToolbar.colors.red;
      } else {
         return Strings.accessibility.annotationToolbar.colors.yellow;
      }
   }

   render() {
      const {themeName} = this.props;
      const colorClass = this.getColorClass();
      const colorPickerClasses = 'color-picker-container ' + colorClass;
      const colorPickerGlyph = <div className="color-picker-glyph">
                                 <ColorSwatch/>
                                 <Glyphs.CaratDown16x16/>
                               </div>;
      const pickerPopover = <div className="popover">
                               <div className="color-picker-colors">
                                  {Constants.annotation.colors.map(color => <button key={color} className="color-picker-color" title={this.getColorText(color)} style={{background: color}} onClick={() => this.handleChange(color)} />)}
                               </div>
                            </div>;

      return (
         <div className={colorPickerClasses}>
            <PopoverButton buttonType={TscButtonType.secondary}
                           buttonTitle={Strings.accessibility.annotationToolbar.colorSelectionAriaLabel.replace('{color}', this.getColorText(this.props.annotationColor.toLowerCase()))}
                           disabled={false}
                           origin={TscPopoverOrigin.topLeft}
                           popoverMenu={pickerPopover}
                           themeName={themeName}
                           closeMenuOnClick={true}
                           buttonGlyph={colorPickerGlyph}
                           testId="color-picker"/>
         </div>
      );
   }
}

export interface ColorPickerProps extends Themeable {
   annotationColor: string;
   setAnnotationColor(color: string): void;
   onColorChange(color: string): void;
}

interface ColorPickerState {
   displayColorPicker: boolean;
}
